import { AxiosError } from 'axios';
import type { ApiError } from '@/models';

export function toApiError(error: unknown): ApiError {
  if (error instanceof AxiosError) {
    const status = error.response?.status ?? 0;
    const data = error.response?.data as { message?: string; details?: Record<string, string[]> } | undefined;
    let message = data?.message ?? error.message;
    if (status === 0) message = 'Network error. Please check your connection and try again.';
    if (status === 401) message = data?.message ?? 'Invalid credentials. Please check your User ID and PIN.';
    if (status === 403) message = data?.message ?? 'You do not have permission to perform this action.';
    if (status >= 500) message = 'An unexpected server error occurred. Please try again later.';
    return { message, status, details: data?.details };
  }
  return { message: error instanceof Error ? error.message : 'Unknown error', status: 0 };
}
